import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import RecordDetailsSidePanel from "../record-details-side-panel";
import AttachmentUtility from "./components/attachment-utility/attachmentsUtility.jsx";
import AttachmentViewer from "./components/attachment-viewer/attachmentViewer.jsx";

const AttachmentsPage = ({isClick}) => {

	const ttData = useSelector((state) => state.tt);
	const ttDocument = ttData.data;

	const [attachmentIndex, setAttachmentIndex] = useState(0);

	useEffect(() => {
		if (isClick) {
			setAttachmentIndex(0);
		}
	}, [isClick]);

	return (
		<div className="success__page__record__details__horizontal" data-testid="success__page__record__details__horizontal">
			<div className="doc_utility_iframe">
				<div className="document_utility_container__display__flex" data-testid="document_utility_container__display__flex">
					<div className="template_label__grey__100" data-testid="template_label__grey__100">
						<AttachmentUtility
							attachments={ttDocument?.canOpenAttachmentArray || []}
							setAttachmentIndex={setAttachmentIndex}
							attachmentIndex={attachmentIndex}
						/>
					</div>
				</div>
				<AttachmentViewer
					selectedAttachment={ttDocument?.canOpenAttachmentArray?.[attachmentIndex]}
				/>
			</div>
			<RecordDetailsSidePanel />
		</div>
	);
};

export default AttachmentsPage;
